<template>
  <th
    :width="width"
    :classes="classes"
  >
    <slot />
  </th>
</template>

<script>
export default {
  name: 'TrTh',
  props: {
    width: {
      required: false,
      type: String
    },
    classes: {
      required: false,
      type: String
    }
  }
};
</script>